/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteAssistantSessionsBySessionId200,
  ErrorResponse,
  GetAssistantFolders200,
  GetAssistantSessions200,
  GetAssistantSessionsBySessionIdMessages200,
  GetAssistantSessionsBySessionIdMessagesParams,
  GetAssistantSessionsContext200,
  GetAssistantSessionsContextParams,
  GetAssistantSessionsParams,
  PostAssistantChatBody,
  PostAssistantEnhancePrompt200,
  PostAssistantEnhancePromptBody,
  PostAssistantSuggestions200,
  PostAssistantSuggestionsBody,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Stream an AI assistant response for a chat turn. Returns a Server-Sent Events stream of UI message events; client should consume with an SSE/AI SDK client. Creates a new session if `sessionId` is omitted.
 * @summary Stream a chat response
 */
export const postAssistantChat = (
    postAssistantChatBody: PostAssistantChatBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/assistant/chat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAssistantChatBody, signal
    },
      );
    }
  


export const getPostAssistantChatMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantChat>>, TError,{data: PostAssistantChatBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAssistantChat>>, TError,{data: PostAssistantChatBody}, TContext> => {

const mutationKey = ['postAssistantChat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssistantChat>>, {data: PostAssistantChatBody}> = (props) => {
          const {data} = props ?? {};

          return  postAssistantChat(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssistantChatMutationResult = NonNullable<Awaited<ReturnType<typeof postAssistantChat>>>
    export type PostAssistantChatMutationBody = PostAssistantChatBody
    export type PostAssistantChatMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Stream a chat response
 */
export const usePostAssistantChat = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantChat>>, TError,{data: PostAssistantChatBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAssistantChat>>,
        TError,
        {data: PostAssistantChatBody},
        TContext
      > => {

      const mutationOptions = getPostAssistantChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Rewrite a short user prompt into a more effective version, returning the enhanced prompt and any detected variables. Requires at least 3 words.
 * @summary Enhance a user prompt
 */
export const postAssistantEnhancePrompt = (
    postAssistantEnhancePromptBody: PostAssistantEnhancePromptBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAssistantEnhancePrompt200>(
      {url: `/assistant/enhance-prompt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAssistantEnhancePromptBody, signal
    },
      );
    }
  


export const getPostAssistantEnhancePromptMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantEnhancePrompt>>, TError,{data: PostAssistantEnhancePromptBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAssistantEnhancePrompt>>, TError,{data: PostAssistantEnhancePromptBody}, TContext> => {

const mutationKey = ['postAssistantEnhancePrompt'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssistantEnhancePrompt>>, {data: PostAssistantEnhancePromptBody}> = (props) => {
          const {data} = props ?? {};

          return  postAssistantEnhancePrompt(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssistantEnhancePromptMutationResult = NonNullable<Awaited<ReturnType<typeof postAssistantEnhancePrompt>>>
    export type PostAssistantEnhancePromptMutationBody = PostAssistantEnhancePromptBody
    export type PostAssistantEnhancePromptMutationError = ErrorResponse

    /**
 * @summary Enhance a user prompt
 */
export const usePostAssistantEnhancePrompt = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantEnhancePrompt>>, TError,{data: PostAssistantEnhancePromptBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAssistantEnhancePrompt>>,
        TError,
        {data: PostAssistantEnhancePromptBody},
        TContext
      > => {

      const mutationOptions = getPostAssistantEnhancePromptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List the authenticated user’s mail folders (excluding hidden/system folders). Uses a cached snapshot, warming the cache on first use.
 * @summary List mail folders
 */
export const getAssistantFolders = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAssistantFolders200>(
      {url: `/assistant/folders`, method: 'GET', signal
    },
      );
    }
  



export const getGetAssistantFoldersQueryKey = () => {
    return [
    `/assistant/folders`
    ] as const;
    }

    
export const getGetAssistantFoldersQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantFolders>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantFoldersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantFolders>>> = ({ signal }) => getAssistantFolders(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantFolders>>>
export type GetAssistantFoldersQueryError = ErrorResponse


export function useGetAssistantFolders<TData = Awaited<ReturnType<typeof getAssistantFolders>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantFolders>>,
          TError,
          Awaited<ReturnType<typeof getAssistantFolders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantFolders<TData = Awaited<ReturnType<typeof getAssistantFolders>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantFolders>>,
          TError,
          Awaited<ReturnType<typeof getAssistantFolders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantFolders<TData = Awaited<ReturnType<typeof getAssistantFolders>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List mail folders
 */

export function useGetAssistantFolders<TData = Awaited<ReturnType<typeof getAssistantFolders>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantFolders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantFoldersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List the authenticated user’s assistant sessions, paginated and optionally filtered by search.
 * @summary List assistant sessions
 */
export const getAssistantSessions = (
    params?: GetAssistantSessionsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAssistantSessions200>(
      {url: `/assistant/sessions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAssistantSessionsQueryKey = (params?: GetAssistantSessionsParams,) => {
    return [
    `/assistant/sessions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAssistantSessionsQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantSessions>>, TError = ValidationErrorResponse | ErrorResponse>(params?: GetAssistantSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantSessionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantSessions>>> = ({ signal }) => getAssistantSessions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantSessions>>>
export type GetAssistantSessionsQueryError = ValidationErrorResponse | ErrorResponse


export function useGetAssistantSessions<TData = Awaited<ReturnType<typeof getAssistantSessions>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: undefined |  GetAssistantSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessions<TData = Awaited<ReturnType<typeof getAssistantSessions>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessions<TData = Awaited<ReturnType<typeof getAssistantSessions>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List assistant sessions
 */

export function useGetAssistantSessions<TData = Awaited<ReturnType<typeof getAssistantSessions>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Find an existing assistant session that matches the given email, draft, or conversation context. Returns `null` data when no session matches.
 * @summary Find session by context
 */
export const getAssistantSessionsContext = (
    params?: GetAssistantSessionsContextParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAssistantSessionsContext200>(
      {url: `/assistant/sessions/context`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAssistantSessionsContextQueryKey = (params?: GetAssistantSessionsContextParams,) => {
    return [
    `/assistant/sessions/context`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAssistantSessionsContextQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError = ValidationErrorResponse | ErrorResponse>(params?: GetAssistantSessionsContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantSessionsContextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantSessionsContext>>> = ({ signal }) => getAssistantSessionsContext(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantSessionsContextQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantSessionsContext>>>
export type GetAssistantSessionsContextQueryError = ValidationErrorResponse | ErrorResponse


export function useGetAssistantSessionsContext<TData = Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError = ValidationErrorResponse | ErrorResponse>(
 params: undefined |  GetAssistantSessionsContextParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessionsContext>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessionsContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessionsContext<TData = Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessionsContext>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessionsContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessionsContext<TData = Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find session by context
 */

export function useGetAssistantSessionsContext<TData = Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError = ValidationErrorResponse | ErrorResponse>(
 params?: GetAssistantSessionsContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsContext>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantSessionsContextQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve a paginated, cursor-based slice of messages for a session, along with session metadata and attachments.
 * @summary Get session history
 */
export const getAssistantSessionsBySessionIdMessages = (
    sessionId: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAssistantSessionsBySessionIdMessages200>(
      {url: `/assistant/sessions/${sessionId}/messages`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAssistantSessionsBySessionIdMessagesQueryKey = (sessionId?: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams,) => {
    return [
    `/assistant/sessions/${sessionId}/messages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAssistantSessionsBySessionIdMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError = ErrorResponse>(sessionId: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssistantSessionsBySessionIdMessagesQueryKey(sessionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>> = ({ signal }) => getAssistantSessionsBySessionIdMessages(sessionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssistantSessionsBySessionIdMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>>
export type GetAssistantSessionsBySessionIdMessagesQueryError = ErrorResponse


export function useGetAssistantSessionsBySessionIdMessages<TData = Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError = ErrorResponse>(
 sessionId: string,
    params: undefined |  GetAssistantSessionsBySessionIdMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessionsBySessionIdMessages<TData = Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError = ErrorResponse>(
 sessionId: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssistantSessionsBySessionIdMessages<TData = Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError = ErrorResponse>(
 sessionId: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get session history
 */

export function useGetAssistantSessionsBySessionIdMessages<TData = Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError = ErrorResponse>(
 sessionId: string,
    params?: GetAssistantSessionsBySessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssistantSessionsBySessionIdMessages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssistantSessionsBySessionIdMessagesQueryOptions(sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Soft-delete an assistant session belonging to the authenticated user.
 * @summary Delete a session
 */
export const deleteAssistantSessionsBySessionId = (
    sessionId: string,
 ) => {
      
      
      return customInstance<DeleteAssistantSessionsBySessionId200>(
      {url: `/assistant/sessions/${sessionId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAssistantSessionsBySessionIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['deleteAssistantSessionsBySessionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  deleteAssistantSessionsBySessionId(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssistantSessionsBySessionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>>
    
    export type DeleteAssistantSessionsBySessionIdMutationError = ErrorResponse

    /**
 * @summary Delete a session
 */
export const useDeleteAssistantSessionsBySessionId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>, TError,{sessionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssistantSessionsBySessionId>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAssistantSessionsBySessionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Generate context-aware smart suggestions for an email, thread, or inbox view.
 * @summary Get smart suggestions
 */
export const postAssistantSuggestions = (
    postAssistantSuggestionsBody: PostAssistantSuggestionsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostAssistantSuggestions200>(
      {url: `/assistant-suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAssistantSuggestionsBody, signal
    },
      );
    }
  


export const getPostAssistantSuggestionsMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantSuggestions>>, TError,{data: PostAssistantSuggestionsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAssistantSuggestions>>, TError,{data: PostAssistantSuggestionsBody}, TContext> => {

const mutationKey = ['postAssistantSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAssistantSuggestions>>, {data: PostAssistantSuggestionsBody}> = (props) => {
          const {data} = props ?? {};

          return  postAssistantSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAssistantSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAssistantSuggestions>>>
    export type PostAssistantSuggestionsMutationBody = PostAssistantSuggestionsBody
    export type PostAssistantSuggestionsMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Get smart suggestions
 */
export const usePostAssistantSuggestions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAssistantSuggestions>>, TError,{data: PostAssistantSuggestionsBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAssistantSuggestions>>,
        TError,
        {data: PostAssistantSuggestionsBody},
        TContext
      > => {

      const mutationOptions = getPostAssistantSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    